import { useEffect } from 'react'

export const usePageDataLog = () => {
  useEffect(() => {
    if (typeof window === 'undefined' || process.env.NODE_ENV !== 'development')
      return
    const data = document.getElementById('__NEXT_DATA__')
    if (!data?.textContent) return

    const parsedData = JSON.parse(data.textContent)

    const jsonString = JSON.stringify(parsedData)
    const bytes = new TextEncoder().encode(jsonString).length
    const mb = bytes / 1024 / 1024

    console.log(parsedData?.props.pageProps)

    const getObjectSizes = (obj: any, depth = 1) => {
      const sizes: { path: string; size: number }[] = []

      const calculateSize = (object: any, path: string) => {
        const jsonString = JSON.stringify(object)
        const bytes = new TextEncoder().encode(jsonString).length
        const mb = bytes / 1024 / 1024
        sizes.push({ path, size: mb })
      }

      const traverse = (obj: any, path = '', currentDepth = 1) => {
        if (currentDepth > depth) return

        for (const key in obj) {
          if (typeof obj[key] === 'object' && obj[key] !== null) {
            const newPath = path ? `${path}.${key}` : key
            calculateSize(obj[key], newPath)
            traverse(obj[key], newPath, currentDepth + 1)
          }
        }
      }

      traverse(obj)
      return sizes
    }

    const sizes = getObjectSizes(parsedData?.props.pageProps, 2)
    sizes.sort((a, b) => b.size - a.size)

    console.log(
      '%c \nTotal Size: ' +
        mb.toFixed(2) +
        'MB' +
        '\n' +
        '%cObject sizes by path (MB):',
      'font-weight: bold; font-size: 12px; line-height: 12px;',
      'font-weight: bold; font-size: 12px; line-height: 12px;'
    )
    sizes.forEach(({ path, size }) => {
      console.table({ path, size: size.toFixed(2) })
    })
  }, [])
}
